import { render, staticRenderFns } from "./onboardSidebar.vue?vue&type=template&id=34a63c1e&scoped=true"
import script from "./onboardSidebar.vue?vue&type=script&lang=js"
export * from "./onboardSidebar.vue?vue&type=script&lang=js"
import style0 from "./onboardSidebar.vue?vue&type=style&index=0&id=34a63c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a63c1e",
  null
  
)

export default component.exports